import React from 'react';
import { FlameIcon } from 'lucide-react';
type ScarcityBarProps = {
  tone?: 'light' | 'dark';
  spotsLeft?: number;
};
export function ScarcityBar({
  tone = 'light',
  spotsLeft = 12
}: ScarcityBarProps) {
  const isDark = tone === 'dark';
  return <div className={['w-full rounded-2xl px-4 py-4 sm:px-5', isDark ? 'bg-white/[0.06] ring-1 ring-white/15' : 'bg-white ring-1 ring-navy-900/10'].join(' ')} data-id="element-51" data-mp="2l4o2v6l5e1g2">
      <div className="flex items-center gap-2" data-id="element-52" data-mp="2b5fc0mlkx2xx">
        <FlameIcon className="h-4 w-4 shrink-0 text-orange-500" aria-hidden="true" data-id="element-53" data-mp="2g6csmuqxxoxb" />
        <p className={['text-[12.5px] font-bold uppercase tracking-[0.06em] sm:text-sm', isDark ? 'text-white' : 'text-navy-900'].join(' ')} data-id="element-54" data-mp="226bqlbyxwbg9">
          Only {spotsLeft} spots left at the launch price
        </p>
      </div>

      <div className={['mt-3 h-3 w-full overflow-hidden rounded-full', isDark ? 'bg-white/15' : 'bg-navy-900/10'].join(' ')} role="img" aria-label={`Launch price nearly claimed — only ${spotsLeft} spots left`} data-id="element-55" data-mp="culaeya7moo">
        <div className="h-full rounded-full bg-orange-500" style={{
        width: '94%'
      }} data-id="element-56" data-mp="2zkrsdmcppqg8" />
      </div>

      <p className={['mt-2 text-[12px] font-medium sm:text-[13px]', isDark ? 'text-white/65' : 'text-navy-800/70'].join(' ')} data-id="element-57" data-mp="3deiui9o4681x">
        94% of the launch-price spots have already been claimed.
      </p>
    </div>;
}